export default __webpack_public_path__ + "static/media/clientImg3.59eb5bd8.png";